module.exports = __webpack_public_path__ + "img/qrcode-wechatpay.61c9340a.jpg";